module.exports = __webpack_public_path__ + "static/media/Colette Single Bed Base - 90x200 cm_Beige.0c266a66.png";